// extracted by mini-css-extract-plugin
module.exports = {"drawer_offcanvas":"AccountDrawer_drawer_offcanvas__bA4A1","close_icon":"AccountDrawer_close_icon__G9vnZ"};